export default __webpack_public_path__ + "static/media/double-deck-01.007e910b.svg";